document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    if (event.target.closest('.spb-label-tooltip')) {
      const button = event.target.closest('.spb-label-tooltip');
      const container = button.parentElement;
      const content = container.querySelector('.spb-label-tooltip + span');

      if (container.classList.contains('expanded')) {
        container.classList.remove('expanded');
        content.style.display = 'none';
      } else {
        container.classList.add('expanded');
        content.style.display = 'flex';
      }
    }

    if (event.target.closest('#infiniteoptions-container span fieldset > label')) {
      const label = event.target.closest('#infiniteoptions-container span fieldset > label');
      const input = label.querySelector('input');
      const fieldset = label.closest('fieldset');
      const container = fieldset.parentElement;
      const group = container.parentElement;
      const inputs = fieldset.querySelectorAll('label input');
      const tooltip = group.querySelector('.spb-label-tooltip > label');

      let inputsSelected = 0;
      let inputsText = [];

      inputs.forEach(input => {
        if (input.checked) {
          inputsSelected++;
          inputsText.push(input.value);
        }
      });

      tooltip.querySelectorAll('span').forEach(span => span.remove());

      if (inputsSelected === 1) {
        tooltip.insertAdjacentHTML('beforeend', `<span style="color: #b32d8d;"> → ${inputsText[0]}</span>`);
      } else if (inputsSelected > 1 && inputsSelected <= 9) {
        tooltip.insertAdjacentHTML('beforeend', `<span style="color: #b32d8d;"> → ${inputsSelected} Selected</span>`);
      } else if (inputsSelected > 9) {
        tooltip.insertAdjacentHTML('beforeend', `<span style="color: #b32d8d;"> → +9 Selected</span>`);
      }
    }

    if (event.target.closest('#infiniteoptions-container label.spb-productoptionswatchwrapper')) {
      const label = event.target.closest('#infiniteoptions-container label.spb-productoptionswatchwrapper');
      const input = label.querySelector('input');
      const container = label.parentElement;
      const group = container.parentElement;
      const tooltip = group.querySelector('.spb-label-tooltip > label');

      tooltip.querySelectorAll('span').forEach(span => span.remove());

      if (
        input.value.toLowerCase().includes('same as picture') ||
        input.value.toLowerCase().includes('standard') ||
        input.value.toLowerCase().includes('none') ||
        input.value.toLowerCase().includes('natural')
      ) {
        tooltip.querySelectorAll('span').forEach(span => span.remove());
      } else {
        tooltip.insertAdjacentHTML('beforeend', `<span style="color: #b32d8d;"> → ${input.value}</span>`);
      }
    }
  });

  let pdpOptionsInterval = setInterval(function () {
    const options = document.querySelectorAll('#infiniteoptions-container > div > span');
    if (options.length > 0) {
      console.log('pdp options checking if is open');
      document.querySelectorAll('#infiniteoptions-container > div').forEach(container => {
        if (container.style.display !== 'none') {
          container.classList.add('expanded');
          clearInterval(pdpOptionsInterval);
        }
      });
    }
  }, 250);
});